export default "__VITE_ASSET__Brl01FlD__"